import { create } from 'zustand';

interface PickemStore {
  checkedUsers: number[];
  setCheckedUsers: (checkedUsers: number[]) => void;

  questionId: number;
  setQuestionId: (questionId: number) => void;

  isOrderingMode: boolean;
  setIsOrderingMode: (isOrderingMode: boolean) => void;

  isScoringMode: boolean;
  setIsScoringMode: (isScoringMode: boolean) => void;

  isPrivateCompetition: boolean;
  setIsPrivateCompetition: (isPrivateCompetition: boolean) => void;
}

export const usePickemStore = create<PickemStore>((set) => ({
  checkedUsers: [],
  setCheckedUsers: (checkedUsers) => set({ checkedUsers }),

  questionId: 0,
  setQuestionId: (questionId) => set({ questionId }),

  isOrderingMode: false,
  setIsOrderingMode: (isOrderingMode) => set({ isOrderingMode }),

  isScoringMode: false,
  setIsScoringMode: (isScoringMode) => set({ isScoringMode }),

  isPrivateCompetition: false,
  setIsPrivateCompetition: (isPrivateCompetition) =>
    set({ isPrivateCompetition }),
}));
